// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "td[data-v-8e4a2e14],\nth[data-v-8e4a2e14] {\n  vertical-align: middle;\n}\n[data-v-8e4a2e14] .multiselect__single,[data-v-8e4a2e14] .multiselect__option {\n  white-space: pre-line;\n}", ""]);
// Exports
module.exports = exports;
